import { parseSanitizedHtml } from "@/utils/sanitizeHtml";
import Rose from './Rose';
import { useCallback, useEffect, useMemo, useRef } from "react";
import Helpers from "@/Helpers";

export default function Rose30(props) {
   const { sectionData, values, setValue } = props;
   const currentSection = sectionData?.currentSection;
   const content: Record<string, string> = Helpers.getSectionContent(currentSection, sectionData?.lang);
   const elements = Helpers.getSectionElements(content);
   const contentValues = useMemo(() => (Array.isArray(elements?.items) ? elements.items : []), [elements]);
   const instructionsHtml = Helpers.getSectionHtmlValue(content, "instructions");
   const reminderHtml = Helpers.getSectionHtmlValue(content, "reminder");
   const headers = Array.isArray(elements?.headers) ? elements.headers : [];
   const containerRef = useRef(null);
   const isAdminMode = sectionData?.isAdmin === true;

   const onChange = useCallback((childId, value) => {
      setValue(childId, parseInt(value));
   }, [setValue]);

   const getIssueCountForPage = useCallback((validationValues, page) => {
      if (!Array.isArray(contentValues)) {
         return 0; // Return 0 if values array doesn't exist
      }
      const pageValues = contentValues.filter((m) => isOnPage(m, page));
      const count = pageValues.filter((m) => {
         const answer = validationValues[currentSection.formId + m.id];
         return answer === undefined || answer === null || answer === "" || Number(answer) === 0;
      }).length;
      return count;
   }, [contentValues, currentSection?.formId]);

   function isOnPage(item, page) {
      return Number(item?.page) === Number(page);
   }

   useEffect(() => {
      if (typeof sectionData?.registerSection !== "function") return;
      sectionData.registerSection( 767);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [currentSection?.name, contentValues.length]);

   useEffect(() => {
      const container = containerRef.current;
      if (!container) return;
      if (!isAdminMode) return;

      const handleKeyDown = (e) => {
         if (isAdminMode) {
            // Handle number keys 1-4 for radio button selection
            if (e.key >= '1' && e.key <= '4') {
               e.preventDefault();
               const keyValue = parseInt(e.key);

               // Find the first unfilled motivator on current page
                const page = Number(sectionData?.page || 1);
               const pageMotivators = contentValues.filter((m) => isOnPage(m, page));

               for (const motivator of pageMotivators) {
                  const fieldId = currentSection.formId + motivator.id;
                  const currentValue = values[fieldId];

                  if (!currentValue || currentValue === 0) {
                     // Found first unfilled motivator, set its value
                     void onChange(motivator.id, keyValue);
                     return;
                  }
               }
            }
            // Handle Enter key for next page
            else if (e.key === 'Enter') {
               e.preventDefault();
               if (sectionData.onNextPage)
                  sectionData.onNextPage();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);

      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   // eslint-disable-next-line react-hooks/exhaustive-deps
}, [isAdminMode, currentSection?.formId, contentValues, values, onChange]);

   useEffect(() => {
      const nextCount = Number(sectionData?.nextCount || 0);
      const page = Number(sectionData?.page || 1);
      const issueCount = nextCount > 0 ? getIssueCountForPage(values || {}, page) : 0;
      sectionData?.updateIssueCount?.(issueCount);
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [sectionData?.nextCount, sectionData?.page, sectionData?.updateIssueCount, values, getIssueCountForPage]);

   const page = Number(sectionData?.page || 1);
   return (
      <div className="Rose" >
         <div className="instructions" ref={containerRef}>
            <p>{parseSanitizedHtml((page > 1 ? reminderHtml : instructionsHtml) || "")}</p>
         </div>

         <table className="tableData center highlightEven no-select">
            <thead>
               <tr>
                  <th className="check columnheader columndata description" >{headers?.[0]}</th>
                  <th className="name columnheader columndata center columnDescription">{headers?.[1]}</th>
                  <th className="name columnheader columndata center columnDescription">{headers?.[2]}</th>
                  <th className="name columnheader columndata center columnDescription">{headers?.[3]}</th>
                  <th className="name columnheader columndata center columnDescription">{headers?.[4]}</th>
               </tr>
            </thead>
            <tbody>
               {contentValues.filter((m) => isOnPage(m, page)).map((p) => {
                  return (
                     <Rose
                        page={page}
                        data={elements}
                        rose={p}
                        key={p.id}
                        setValue={setValue}
                        value={values[currentSection.formId + p.id] ?? ""}
                        showValidations={sectionData.showValidations}
                     />
                  )
               })}
            </tbody>
         </table>
      </div>
   )
}

